import Header from '../../../shared/Header/Header';
import Footer from '../../../shared/Footer/Footer';
import SectionHeader from '../../../layouts/showcaseLayouts/Section/SectionHeader/SectionHeader';
import BackButton from '../../../shared/backButton/BackButton';
import SectionBody from '../../../layouts/showcaseLayouts/Section/SectionBody/SectionBody';
import useIsLTE650 from '../../../../hooks/useIsLTE650';
import './deliveryPaymentPage.scss';

const DeliveryPaymentPage: React.FC = () => {
    const isMobile = useIsLTE650(650);

    return (
        <div className="deliveryPaymentPage">
            <Header isMobile={isMobile} />
            <div className="deliveryPaymentPage_headerWrapper">
                <BackButton absolute />
                <SectionHeader title={'Доставка и оплата'} />
            </div>
            <SectionBody>
                <div style={{ padding: '0 1rem' }}>
                    <p style={{ margin: '0 0 0.5rem', fontWeight: '400', textTransform: 'uppercase', textAlign: 'center' }}>
                        перед завершением заказа, вы можете в корзине выбрать один из способов оплаты: <br />
                        картой он-лайн или оплата через СБП.
                    </p>
                    <p style={{ margin: '0 0 0.5rem', fontWeight: '400', textTransform: 'uppercase', textAlign: 'center' }}>
                        Воможна оплата за товары, представленные на сайте по безналичному расчету.
                    </p>
                    <div className="deliveryPaymentPage__titleBox">
                        <h2 className="deliveryPaymentPage__titleBox_title">ОПЛАТА</h2>

                        <div className="deliveryPaymentPage__titleBox_imgWrapper">
                            <img className="deliveryPaymentPage__titleBox_img" src="/delivery-payment/visa-masterCard.png" alt="visa-masterCard" />
                            <img className="deliveryPaymentPage__titleBox_img" src="/delivery-payment/mir.png" alt="Мир" />
                        </div>
                    </div>

                    <div className="deliveryPaymentPage__contentBox">
                        <div
                            style={{
                                boxShadow: '0 0 1px 2px rgba(0,0,0,0.1)',
                                borderRadius: '0.3rem',
                                padding: '1rem 1.5rem',
                                margin: '0.5rem 0 1rem',
                            }}
                        >
                            <p>
                                <strong>Оплата картой онлайн</strong>
                            </p>
                            <p>
                                При выборе этого способа оплаты товара, Вы будете перенаправлены на платежный сервис для ввода следующих данных о Вашей карте: номер
                                карты, имя и фамилия держателя карты, срок действия карты, защитный код (CVV2/CVC2).
                            </p>
                            <p>
                                Если Ваш банк поддерживает технологию безопасного проведения интернет-платежей Verified By Visa или Secure Code, для проведения
                                операции по карте также может потребоваться ввод одноразового пароля. Способы и возможность получения одноразового пароля для
                                совершения интернет-платежа Вы можете уточнить в банке, выпустившем карту.
                            </p>
                            <p style={{ marginBottom: 0 }}>Компания не передает, не получает, не хранит и не обрабатывает данные о Вашей пластиковой карте.</p>
                        </div>

                        <p>
                            <strong>Оплата через СБП</strong>
                        </p>
                        <p>
                            При выборе этого способа оплаты товара, Вы будете перенаправлены в личный кабинет выбранного Вами банка для проведения платежа через СПБ.
                        </p>

                        <p>
                            <strong>Безналичная оплата</strong>
                        </p>
                        <p>
                            Безналичная оплата товара осуществляется через любой банк, выбранный Клиентом. Клиент делает запрос на выставления Счета для оплаты
                            товаров на электронную почту, указанную в разделе Контакты. В запросе Клиент указывает перечень и количество товаров, которые он хочет
                            купить и оплатить. Запрос по количеству и ассортименту товаров также может быть сформирован в личном кабинете. В этом случае при заказе
                            Счета, Клиент указывает номер Заказа. При заказе Счета, Клиент обязан указать организацию плательщика с реквизитами. Клиентский менеджер
                            направляет Счет на электронную почту Клиента, указанную в запросе на выставление счета. Заказ считается оплаченным при зачислении
                            денежных средств на расчетный счет ООО «ИНТРЕЙД».
                        </p>
                        <h2 className="deliveryPaymentPage__contentBox_title">ДОСТАВКА</h2>

                        <p>
                            <strong>Товар доставляется только по 100 % предоплате.</strong>
                        </p>
                        <p>
                            <b>Максимальный срок резервирования товара по заказу до его полной оплаты - не более 1 рабочего дня</b>.
                        </p>
                        <p>
                            Товар доставляется до указанного Вами в личном кабинете или при оформлении заказа адреса. Выбор способа получения товара Вы можете
                            сделать при начале оформления заказа через корзину. Возможными опциями являются:
                        </p>

                        <ul className="deliveryPaymentPage__contentBox_list">
                            <li>Доставка до двери Клиента по указанному адресу службой DPD.</li>
                            <li>Самовывоз по адресу склада Поставщика : 141580, МО, г. Химки, с. Чашниково, ул. Промышленная, стр. 1, корпус 4.</li>
                        </ul>

                        <p>
                            Заказы <b>по Москве и Московской области</b> доставляются курьером в течение 3-х рабочих дней с момента оплаты заказа на сайте. При
                            заказе в субботу и воскресенье, срок доставки будет считаться с понедельника. Срок доставки в регионы определяется стандартным сроком
                            доставки транспортной компании DPD. Стоимость доставки Вы сможете увидеть при оформлении заказа, выбрав опцию «доставка до двери» и введя
                            адрес доставки.
                        </p>
                        <p>
                            <b>Стоимость доставки включается в заказ и оплачивается одновременно с товаром.</b>
                        </p>
                        <p>Заказы по всей России и странам ближнего зарубежья доставляются службами доставки DPD Торгового Дома ГАБАЙ.</p>
                        <p>
                            Если у Вас есть вопросы по доставке или срокам доставки, Вы всегда можете задать их по телефону или электронной почте из раздела
                            контакты.
                        </p>

                        <p>
                            <strong>Сроки доставки Заказов по предоплате со склада в Китае:</strong>
                        </p>
                        <p>
                            <b>
                                Вся продукция, которая в данный момент отсутствует на складе в Москве, но представленная на сайте, может быть заказана и доставлена в
                                срок 20 рабочих дней по предварительной оплате заказа.
                            </b>
                        </p>
                        <p>
                            В случае отсутствия товара в данный момент на складе в Москве, Вы можете сделать предварительный заказ всей продукции на сайте и оплатить
                            его. Ваш заказ будет доставлен Вам с нашего склада в Китае не позднее 20 рабочих дней с момента оплаты Заказа. По всем вопросам по
                            предварительным заказам, Вы можете всегда получить дополнительную информацию, обратившись к нам по телефону или электронной почте в
                            разделе Контакты.
                        </p>
                    </div>
                </div>
            </SectionBody>

            <Footer isMobile={isMobile} />
        </div>
    );
};

export default DeliveryPaymentPage;
